import { render, staticRenderFns } from "./AdminOrdersMaterial.vue?vue&type=template&id=2c3dacb7&scoped=true"
import script from "./AdminOrdersMaterial.vue?vue&type=script&lang=js"
export * from "./AdminOrdersMaterial.vue?vue&type=script&lang=js"
import style0 from "./AdminOrdersMaterial.vue?vue&type=style&index=0&id=2c3dacb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dacb7",
  null
  
)

export default component.exports